export const state = () => ({
  supportContact: process.env.WA_CONTACT_1
})
